import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown, FaChevronRight } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import "../Navbar/Navbar.css";

const Navbar = () => {
  const [hideTop, setHideTop] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const desktopRef = useRef(null);
  const mobileRef = useRef(null);

  /* ===== hide top bar on scroll ===== */
  useEffect(() => {
    const onScroll = () => setHideTop(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* ===== close dropdown on outside click ===== */
  useEffect(() => {
    const handler = (e) => {
      if (
        desktopRef.current &&
        !desktopRef.current.contains(e.target) &&
        mobileRef.current &&
        !mobileRef.current.contains(e.target)
      ) {
        setOpenDropdown(null);
        setActiveSubMenu(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const toggleDropdown = (name) => {
    if (openDropdown === name) {
      setOpenDropdown(null);
      setActiveSubMenu(null);
    } else {
      setOpenDropdown(name);
      setActiveSubMenu(null);
    }
  };

  const handleSubMenuHover = (destination) => {
    if (openDropdown === "dest") {
      setActiveSubMenu(destination);
    }
  };

  const handleSubMenuClick = (destination) => {
    if (openDropdown === "dest") {
      setActiveSubMenu(activeSubMenu === destination ? null : destination);
    }
  };

  // Function to close all dropdowns
  const closeAllDropdowns = () => {
    setOpenDropdown(null);
    setActiveSubMenu(null);
  };

  const destinationData = {
    usa: [
      { name: "Orlando", path: "/destination/usa/orlando" },
      { name: "New York", path: "/destination/usa/new-york" },
      { name: "Miami", path: "/destination/usa/miami" },
      { name: "Las Vegas", path: "/destination/usa/las-vegas" },
      { name: "Atlanta", path: "/destination/usa/atlanta" },
      { name: "Dallas", path: "/destination/usa/dallas" },
      { name: "Washington", path: "/destination/usa/washington" },
      { name: "San Francisco", path: "/destination/usa/san-francisco" },
      { name: "Tampa", path: "/destination/usa/tampa" },
    ],

    canada: [
      { name: "Toronto", path: "/destination/canada/toronto" },
      { name: "Vancouver", path: "/destination/canada/vancouver" },
      { name: "Calgary", path: "/destination/canada/calgary" },
      { name: "Montreal", path: "/destination/canada/montreal" },
    ],

    caribbean: [
      { name: "Montego Bay", path: "/destination/caribbean/montego-bay" },
      { name: "Kingston", path: "/destination/caribbean/kingston" },
      { name: "Barbados", path: "/destination/caribbean/barbados" },
      { name: "Antigua", path: "/destination/caribbean/antigua" },
      { name: "Grenada", path: "/destination/caribbean/grenada" },
    ],

    "australia-nz": [
      { name: "Sydney", path: "/destination/a&n/sydney" },
      { name: "Brisbane", path: "/destination/a&n/brisbane" },
      { name: "Melbourne", path: "/destination/a&n/melbourne" },
      { name: "Perth", path: "/destination/a&n/perth" },
      { name: "Auckland", path: "/destination/a&n/auckland" },
    ],

    africa: [
      { name: "Lagos", path: "/destination/africa/lagos" },
      { name: "Accra", path: "/destination/africa/accra" },
      { name: "Harare", path: "/destination/africa/harare" },
      { name: "Cape Town", path: "/destination/africa/cape-town" },
      { name: "Entebbe", path: "/destination/africa/entebbe" },
    ],

    "latin-america": [
      { name: "Cali", path: "/destination/latin-america/cali" },
      { name: "Quito", path: "/destination/latin-america/quito" },
      { name: "Lima", path: "/destination/latin-america/lima" },
      { name: "Bogota", path: "/destination/latin-america/bogota" },
      { name: "Sao Paulo", path: "/destination/latin-america/sao-paulo" },
    ],

    asia: [
      { name: "Bangkok", path: "/destination/asia/bangkok" },
      { name: "Dubai", path: "/destination/asia/dubai" },
      { name: "Bali", path: "/destination/asia/bali" },
      { name: "Phuket", path: "/destination/asia/phuket" },
      { name: "Delhi", path: "/destination/asia/delhi" },
      { name: "Mumbai", path: "/destination/asia/mumbai" },
      { name: "Chennai", path: "/destination/asia/chennai" },
    ],
  };

  const getDestinationName = (key) => {
    switch (key) {
      case "usa":
        return "USA";
      case "australia-nz":
        return "Australia & NZ";
      case "latin-america":
        return "Latin America";
      case "caribbean":
        return "Caribbean";
      default:
        // capitalize words and replace hyphens with spaces
        return key
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
    }
  };

  return (
    <header className="navbar-wrapper">
      {/* ================= TOP BAR ==========
      <div className={`top-bar ${hideTop ? "top-hide" : ""}`}>
        <div className="top-left">
          <NavLink to="/" onClick={closeAllDropdowns}>
            <img src="/logo.webp" alt="logo" className="nav-logo" />
          </NavLink>
        </div>

        <div className="top-center">
          <img src="/atol.webp" alt="atol" />
         
        </div>

        <div className="top-right">
          <a href="tel:02033557350  " onClick={closeAllDropdowns}>
            <IoCall /> 02033557350  
          </a>
          <span>24×7 Support</span>
        </div>
      </div>
      ======= */}

      {/* ================= DESKTOP NAV ================= */}
      <nav className={`bottom-nav ${hideTop ? "scrolled" : ""}`}>
        <div className="bottom-left">
          {/*--  {hideTop && ( --*/}
          <NavLink to="/" onClick={closeAllDropdowns}>
            <img src="/logo.webp" alt="logo" className="nav-logo-m" />
          </NavLink>
          {/*--  )} --*/}
        </div>

        <ul className="menu-list" ref={desktopRef}>
          <li>
            <NavLink to="/" onClick={closeAllDropdowns}>
              Home
            </NavLink>
          </li>

          {/* ===== DESTINATIONS ===== */}
          <li
            className={`has-dropdown ${openDropdown === "dest" ? "open" : ""}`}
            onMouseEnter={() =>
              openDropdown === "dest" && setActiveSubMenu(null)
            }
          >
            <div className="dropdown-toggle">
              <NavLink
                to="/flight"
                className="dropdown-link"
                onClick={closeAllDropdowns}
              >
                Destinations
              </NavLink>

              <span
                className="dropdown-arrow"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDropdown("dest");
                }}
              >
                <FaChevronDown
                  className={`arrow ${openDropdown === "dest" ? "rotate" : ""}`}
                />
              </span>
            </div>

            <div className="dropdown-container">
              {/* Main destinations dropdown */}
              <ul className="dropdown">
                {Object.keys(destinationData).map((key) => (
                  <li
                    key={key}
                    className="dropdown-item-with-arrow"
                    onMouseEnter={() => handleSubMenuHover(key)}
                  >
                    <div className="destination-item">
                      <span className="destination-namen">
                        {getDestinationName(key)}
                      </span>
                      {activeSubMenu === key && (
                        <span className="destination-arrow">
                          <FaChevronRight />
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>

              {/* Sub-dropdown for cities */}
              {activeSubMenu && (
                <div className="sub-dropdown-container">
                  <ul className="sub-dropdown">
                    {destinationData[activeSubMenu].map((item) => (
                      <li key={item.name}>
                        <NavLink to={item.path} onClick={closeAllDropdowns}>
                          {item.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </li>

          {/* ===== HOLIDAYS ===== */}
          <li
            className={`has-dropdown ${
              openDropdown === "holiday" ? "open" : ""
            }`}
          >
            <div className="dropdown-toggle">
              <NavLink
                to="/holidays"
                className="dropdown-link"
                onClick={closeAllDropdowns}
              >
                Holidays
              </NavLink>

              <span
                className="dropdown-arrow"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDropdown("holiday");
                }}
              >
                <FaChevronDown
                  className={`arrow ${
                    openDropdown === "holiday" ? "rotate" : ""
                  }`}
                />
              </span>
            </div>

            <ul className="dropdown">
              <li>
                <NavLink to="/holidays/morocco" onClick={closeAllDropdowns}>
                  Morocco
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/dubai" onClick={closeAllDropdowns}>
                  Dubai
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/maldives" onClick={closeAllDropdowns}>
                  Indian Ocean
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/thailand" onClick={closeAllDropdowns}>
                  Thailand
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/indonesia" onClick={closeAllDropdowns}>
                  Indonesia
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/malaysia" onClick={closeAllDropdowns}>
                  Malaysia
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/india" onClick={closeAllDropdowns}>
                  India
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/srilanka" onClick={closeAllDropdowns}>
                  Sri Lanka
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/southafrica" onClick={closeAllDropdowns}>
                  South Africa
                </NavLink>
              </li>
              <li>
                <NavLink to="/holidays/greece" onClick={closeAllDropdowns}>
                  Greece
                </NavLink>
              </li>
            </ul>
          </li>

          <li>
            <NavLink to="/aboutus" onClick={closeAllDropdowns}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/contactus" onClick={closeAllDropdowns}>
              Contact
            </NavLink>
          </li>
        </ul>

        <div className="bottom-right">
          {/*--   {hideTop && ( --*/}
          <div className="call-info">
            <a href="tel:02033557350  " onClick={closeAllDropdowns}>
              <IoCall /> 02033557350
            </a>
            <span>24×7 Support</span>
          </div>
          {/*--   )} --*/}
        </div>
      </nav>

      {/* ================= MOBILE NAV ================= */}
      <div className="mnav-wrapper">
        <div className="mnav-bar">
          <NavLink to="/" onClick={closeAllDropdowns}>
            <img src="/logo.webp" alt="logo" className="nav-logo-mm" />
          </NavLink>
          <img src="/atol.webp" alt="logo" className="nav-atol-logo-mm" />
          <div
            className="mnav-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>

        <div
          ref={mobileRef}
          className={`mnav-drawer ${mobileOpen ? "open" : ""}`}
        >
          {/* Cross sign at top right in slider */}
          <div className="mnav-close-btn" onClick={() => setMobileOpen(false)}>
            <FaTimes />
          </div>

          <ul className="mnav-menu">
            <li>
              <NavLink
                to="/"
                onClick={() => {
                  setMobileOpen(false);
                  closeAllDropdowns();
                }}
              >
                Home
              </NavLink>
            </li>

            {/* MOBILE DESTINATIONS - UPDATED */}
            <li
              className={`mnav-dropdown ${
                openDropdown === "dest" ? "open" : ""
              }`}
            >
              <div className="mnav-toggle-row">
                <NavLink
                  to="/flight"
                  onClick={() => {
                    setMobileOpen(false);
                    closeAllDropdowns();
                  }}
                  className="mnav-main-link"
                >
                  Destinations
                </NavLink>
                <span
                  className="mnav-arrow-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleDropdown("dest");
                  }}
                >
                  <FaChevronDown
                    className={openDropdown === "dest" ? "rotate" : ""}
                  />
                </span>
              </div>

              <ul className="mnav-submenu">
                {Object.keys(destinationData).map((key) => (
                  <li
                    key={key}
                    className={`mnav-subdropdown ${
                      activeSubMenu === key ? "sub-open" : ""
                    }`}
                  >
                    <div
                      className="mnav-subtoggle-row"
                      onClick={() => handleSubMenuClick(key)}
                    >
                      <span>{getDestinationName(key)}</span>
                      <FaChevronRight
                        className={activeSubMenu === key ? "rotate" : ""}
                      />
                    </div>

                    <ul className="mnav-subsubmenu">
                      {destinationData[key].map((item) => (
                        <li key={item.name}>
                          <NavLink
                            to={item.path}
                            onClick={() => {
                              setMobileOpen(false);
                              closeAllDropdowns();
                            }}
                          >
                            {item.name}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </li>

            {/* MOBILE HOLIDAYS - UPDATED */}
            <li
              className={`mnav-dropdown ${
                openDropdown === "holiday" ? "open" : ""
              }`}
            >
              <div className="mnav-toggle-row">
                <NavLink
                  to="/holidays"
                  onClick={() => {
                    setMobileOpen(false);
                    closeAllDropdowns();
                  }}
                  className="mnav-main-link"
                >
                  Holidays
                </NavLink>
                <span
                  className="mnav-arrow-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleDropdown("holiday");
                  }}
                >
                  <FaChevronDown
                    className={openDropdown === "holiday" ? "rotate" : ""}
                  />
                </span>
              </div>

              <ul className="mnav-submenu">
                <li>
                  <NavLink
                    to="/holidays/turkey"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Turkey
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/morocco"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Magical Morocco
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/dubai"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Dubai
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/maldives"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Indian Ocean
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/thailand"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Thailand
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/indonesia"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Indonesia
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/malaysia"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Malaysia
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/india"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    India
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/srilanka"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Sri Lanka
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/southafrica"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    South Africa
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/japan"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Japan
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/holidays/greece"
                    onClick={() => {
                      setMobileOpen(false);
                      closeAllDropdowns();
                    }}
                  >
                    Greece
                  </NavLink>
                </li>
              </ul>
            </li>

            <li>
              <NavLink
                to="/aboutus"
                onClick={() => {
                  setMobileOpen(false);
                  closeAllDropdowns();
                }}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contactus"
                onClick={() => {
                  setMobileOpen(false);
                  closeAllDropdowns();
                }}
              >
                Contact
              </NavLink>
            </li>
          </ul>

          <div className="mnav-contact">
            <a href="tel:02033557350  " onClick={closeAllDropdowns}>
              <IoCall /> 02033557350
            </a>
          </div>
          <div className="mnav-logos">
            <img src="/atol.webp" alt="atol" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
